<div
  class="presentation-selector-container attribute-editor-component"
  rvSpinner="presentation-selector-loader"
  [rvShowSpinner]="playlistComponentFactory.isLoading"
>
  <div class="playlist-templates-title active-search">
    <label>Choose A Presentation</label>
  </div>
  <search-filter
    class="templates-selector-search-box"
    [filterConfig]="filterConfig"
    [search]="playlistComponentFactory.search"
    [doSearch]="playlistComponentFactory.templates.doSearch"
  ></search-filter>
  <div
    class="tw-flex tw-flex-col tw-gap-2.5 tw-px-4 tw-border-solid tw-border-0 tw-border-t tw-border-gray-200"
  >
    @if (playlistComponentFactory.foldersSupported) {
      <folder-path
        [folderTree]="folderService.folderPathTree"
        [folderId]="playlistComponentFactory.folderId"
        (folderClicked)="onFolderClicked($event)"
        rootName="Presentations"
      ></folder-path>
    }
  </div>
  <div
    class="templates-selector te-scrollable-container active-search"
    scrollingList
    (scrollEndEvent)="playlistComponentFactory.templates.load()"
  >
    <div
      id="te-playlist-no-results"
      class="templates-selector-no-results"
      [shown]="!(playlistComponentFactory.items.length > 0)"
    >
      No Presentations found. To create a new Presentation
      <a
        role="button"
        tabindex="0"
        (click)="createNewTemplate()"
        (keyup.enter)="createNewTemplate()"
        (keyup.space)="createNewTemplate()"
        aria-label="Create new presentation"
        >click here</a
      >.
    </div>
    @for (template of playlistComponentFactory.items; track template) {
      @if (template.isFolder) {
        <div
          class="row templates-row folder-row"
          [shown]="playlistComponentFactory.items.length > 0"
          (click)="onFolderClicked(template.id)"
        >
          <div class="tw-flex tw-flex-row tw-items-center tw-gap-2.5">
            <mat-icon svgIcon="folder" class="tw-text-gray-500 tw-ml-1.5" />
            <a
              role="button"
              tabindex="0"
              (click)="$event.stopPropagation(); onFolderClicked(template.id)"
              (keydown.enter)="onFolderClicked(template.id)"
              (keydown.space)="
                $event.preventDefault(); onFolderClicked(template.id)
              "
              class="u_ellipsis-lg templates-name !tw-text-black"
              [attr.aria-label]="'Open folder ' + template.name"
            >
              {{ template.name }}
            </a>
          </div>
        </div>
      } @else {
        <div
          class="row templates-row"
          [shown]="playlistComponentFactory.items.length > 0"
          (click)="playlistComponentFactory.templates.select(template)"
        >
          <mat-checkbox
            id="{{ template.id }}"
            [ngModel]="template.selected"
          ></mat-checkbox>
          <label
            class="templates-selector-name u_text-ellipsis tw-ml-1.5"
            for="{{ template.id }}"
          >
            <span class="templates-name">{{ template.name }}</span>
            <div
              class="templates-status font-weight-normal"
              [ngClass]="{
                'templates-status-revised':
                  template.revisionStatusName === 'Revised',
              }"
            >
              {{ template.revisionStatusName }}
            </div>
          </label>
        </div>
      }
    }
  </div>
  <div class="playlist-action-button-bar">
    <div class="add-templates">
      <button
        rv-button
        id="te-playlist-add-template"
        class="tw-w-full"
        (click)="addTemplates()"
        [disabled]="!playlistComponentFactory.templates.getSelected().length"
      >
        Add Presentation
      </button>
    </div>
  </div>
</div>
